import { CircularProgress, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import useConfig from 'hooks/useConfig';

function SearchInput({ loading, ...props }) {
  return (
    <TextField
      {...props}
      InputProps={{
        ...props.InputProps,
        startAdornment: (
          <InputAdornment position="start">
            {loading ? (
              <CircularProgress size="1.5rem" />
            ) : (
              <SearchIcon />
            )}
          </InputAdornment>
        ),
      }}
      placeholder={useConfig('web.searchPlaceholder', 'Restaurants, drinks, groceries...')}
      sx={{
        width: {
          xs: '100%',
          // md: 400,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '& .MuiInputBase-root': {
          backgroundColor: 'grey.200',
        },
        '& input': {
          height: '1rem',
        },
      }}
    />
  );
}

export default SearchInput;
